import { get } from 'lodash';
const target = 'target';
const value = 'value';
const tags = 'tags';

export const path = 'track/website/instrumentation';

export function map(mapper) {
  const mapping = mapper.getOrCreateMap(path);
  mapping.addMapTo('type', 'instrumentation');
  mapping.addMapTo('platform', '').mapFrom('data.page.platform');
  mapping.addMapTo('edition', '').mapFrom('data.page.country');
  mapping.addMapTo('category', '').mapFrom(src => get(src, 'data.page.category') || 'home');
  mapping.addMapTo(target, '').mapFrom(`data.${target}`);
  mapping.addMapTo(value, '').mapFrom(`data.${value}`);
  mapping.addMapTo(tags, '').mapFrom(src => JSON.stringify(get(src, `data.${tags}`, '')));

  return mapping;
};



// WEBPACK FOOTER //
// /~/@buzzfeed/buzzblocks/js/services/metrics/mapping.js